import { useState } from 'react'
import { useTheme } from '@mui/material'
import {
  Background,
  Container,
  LeftContainer,
  SettingsButton,
  SettingsText,
  TextContainer,
} from '../../settings-details.styles'
import EditAddressSettingsDialog from 'components/edit-address-settings-dialog/edit-address-settings-dialog.component'
import { formatAddress } from 'utils/common'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

const SettingsAddress = () => {
  const theme = useTheme()

  const [open, setOpen] = useState(false)

  const user = useSelector((state: RootState) => state.auth.user)

  return (
    <>
      <Background theme={theme}>
        <Container>
          <LeftContainer>
            <TextContainer>
              <SettingsText>My Company Name: </SettingsText>
              <SettingsText variant="bold">{user?.companyName}</SettingsText>
            </TextContainer>
            <TextContainer>
              <SettingsText>Address: </SettingsText>
              <SettingsText variant="bold">{formatAddress(user)}</SettingsText>
            </TextContainer>
          </LeftContainer>
          <SettingsButton
            variant="contained"
            size="small"
            onClick={() => setOpen(true)}
          >
            Edit Address
          </SettingsButton>
        </Container>
      </Background>
      <EditAddressSettingsDialog
        open={open}
        handleClose={() => setOpen(false)}
      />
    </>
  )
}

export default SettingsAddress
